import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRtDialogBase, registerAllRtConsultEmitters } from '@/composables/useRtDialogBase'


export default /*#__PURE__*/_defineComponent({
  __name: 'RealtimeTransferAppealDialog',
  setup(__props) {

const base = useRtDialogBase({
  openDialogEventName: 'open-realtimetransferappeal-dialog',
  primaryConsultEventName: 'send-realtimetransferappeal-consult',
  primaryConsultHandlerKey: 'sendRealtimeTransferAppealConsult',
  defaultPermissionType: 4,
  defaultClientId: 'medley_link',
  defaultDialogName: 'medley_dialog'
})

// RealtimeTransferCommon と同じく、各クライアントの送客 hub イベント群を一括追加 listen。
// → AppealDialog は「Medley 互換 (sendRealtimeTransferAppealConsult) + 全 RT 共通 send-*」の上位互換ハブとなる。
registerAllRtConsultEmitters(base)

const dialogInfo = base.dialogInfo

/** メインリード文（dialogInfo.text_1 で上書き、既定は「ダウンロードが完了しました！」） */
const leadText1 = computed<string>(() => dialogInfo.value.text_1 ?? 'ダウンロードが完了しました！')
/** サブリード文（あれば表示、HTML 可） */
const leadText2 = computed<string>(() => dialogInfo.value.text_2 ?? '')
/** アピールポイント配列（[{ main, sub? }]） */
const appealPoints = computed<Array<{ main: string; sub?: string }>>(() => {
  const raw = dialogInfo.value.appealPoints
  return Array.isArray(raw) ? raw : []
})
/** 送信ボタン文言（既定: 「同意する」） */
const btnText = computed<string>(() => dialogInfo.value.btn_text ?? '同意する')

// テンプレート互換のための別名
const appealModalVisible = base.modalVisible
const isAppealSended = base.isSended
const closeAppealDialog = base.closeDialog
const onAppealModalOpened = base.onModalOpened
const onAppealModalClosed = base.onModalClosed
const handleBeforeClose = base.handleBeforeClose
const fullscreenLoading = base.fullscreenLoading
const sendRealtimeTransferAppealConsult = base.sendRealtimeTransferAppealConsult

return { __sfc: true,base, dialogInfo, leadText1, leadText2, appealPoints, btnText, appealModalVisible, isAppealSended, closeAppealDialog, onAppealModalOpened, onAppealModalClosed, handleBeforeClose, fullscreenLoading, sendRealtimeTransferAppealConsult }
}

})